export default class FAQ {

  static _handleSearch (searchTerms) {
    document.querySelectorAll('.vol_faq_entry').forEach(faqEntry => {
      const hasHits = searchTerms.reduce((condition, term) =>
        condition || faqEntry.textContent.toLowerCase().includes(term.toLowerCase()), false
      )

      if (hasHits) {
        faqEntry.classList.remove('hidden')

        return
      }

      faqEntry.classList.add('hidden')
    })

    const remaining = document.querySelectorAll('.vol_faq_entry:not(.hidden)')
    const emptyMessage = document.querySelector('.vol_faq_empty')

    if (remaining.length === 0) {
      emptyMessage.classList.remove('hidden')

      return
    }

    emptyMessage.classList.add('hidden')

    const oldLast = document.querySelector('.vol_faq_entry.bottom-line')

    if (oldLast) {
      oldLast.classList.remove('bottom-line')
    }

    // add line to last one since css can't do last visible
    Array.from(remaining).slice(-1)[0].classList.add('bottom-line')
  }

  static _registerSearchEvents () {
    document.querySelector('.vol_faq_search').addEventListener('input', event => {
      const searchTerms = event.target.value.split(' ')

      FAQ._handleSearch(searchTerms)
    })
  }

  static _registerCollapseEvents () {
    document.querySelectorAll('.vol_faq_list .vol_faq_entry_question').forEach(faqEntryQuestion => {
      let parent = faqEntryQuestion.parentNode
      let id = parent.dataset["faqnr"]
      if (id == FAQ.defaultOpen) {
        parent.classList.toggle('collapsed')
        FAQ.defaultElement = parent
      }

      faqEntryQuestion.addEventListener('click', event => {
        event.preventDefault()
        let element = event.target

        while (element.parentNode && !element.classList.contains('vol_faq_entry')) {
          element = element.parentNode
        }
        element.classList.toggle('collapsed')
      })
    })
  }

  static registerEvents () {
    FAQ._registerSearchEvents()
    FAQ._registerCollapseEvents()
    if (FAQ.defaultElement) {

      let rect = FAQ.defaultElement.getBoundingClientRect()

      window.scrollTo({
        top: rect.top - 250,
        left: 0,
        behavior: "instant"
      })
    }
  }

  static init () {
    const faqWrapper = document.querySelector('.vol_faq')

    if (faqWrapper) {
      FAQ.defaultOpen = null
      let h = window.location.hash
      if (h) {
        if (h.indexOf("#faq_") == 0) {
          h = h.replace("#faq_","")
          FAQ.defaultOpen = h
        }
      }
      FAQ.registerEvents()
    }
  }
}
